// src/providers/StoreProvider.jsx

import React, { useEffect } from 'react'
import { Spin } from 'antd'
import useAuthStore from '../stores/authStore'

const StoreProvider = ({ children }) => {
    const { checkAuth, isInitialized, isLoading } = useAuthStore()

    useEffect(() => {
        if (!isInitialized) {
            checkAuth()
        }
    }, [isInitialized, checkAuth])

    if (!isInitialized || isLoading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}>
                <Spin size="large" description="Caricamento..." />
            </div>
        )
    }

    return children
}

export default StoreProvider